import "core-js/modules/es.array.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getStationCheckList, deleteStationCheck } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo';
import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';
import { mapGetters } from "vuex";
import { getDict } from '@/utils/dictionary'; // 获取字典数据的func

var _this;

export default {
  name: 'BairunStationCheck',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatTime: function formatTime(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'MM-dd hh:mm');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].statAbbr;
        }
      }

      return '';
    },
    getSellerName: function getSellerName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  data: function data() {
    return {
      listApi: getStationCheckList,
      type: '',
      showSelSeller: false,
      oilCodeDict: [],
      tankList: [],
      merge: [],
      // 存放需要合并的行
      mergeRowIndex: '',
      // 需要合并行下标
      searchInfo: {
        stationId: '',
        startDate: '',
        endDate: ''
      }
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');
              _context2.next = 3;
              return getDict('oilCode');

            case 3:
              _this2.oilCodeDict = _context2.sent;

              _this2.init();

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.asyncStations && _this3.asyncStations.length === 1) {
                  _this3.searchInfo.stationId = _this3.asyncStations[0].ID;
                }

                _this3.onSubmit();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.showSelSeller = false;
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.dataType = 'sequence';

      if (this.searchInfo.oilCode === '') {
        delete this.searchInfo.oilCode;
      }

      this.getTableData();
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var page, pageSize, table;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this4.page;
                pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this4.pageSize;
                _context4.next = 4;
                return _this4.listApi(_objectSpread({
                  page: page,
                  pageSize: pageSize
                }, _this4.searchInfo));

              case 4:
                table = _context4.sent;

                if (table.code === 0 && table.data.list != null) {
                  _this4.total = table.data.total;
                  _this4.page = table.data.page;
                  _this4.pageSize = table.data.pageSize;

                  _this4.getSpanArr(table.data.list);

                  _this4.tableData = table.data.list;

                  _this4.$forceUpdate();
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.onSubmit();
    },
    onInputChange: function onInputChange() {
      this.$forceUpdate();
    },
    getSpanArr: function getSpanArr(data) {
      this.merge = [];
      this.mergeRowIndex = 0;

      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.merge.push(1);
          this.mergeRowIndex = 0;
        } else {
          if (data[i].dailyNo === data[i - 1].dailyNo) {
            this.merge[this.mergeRowIndex] += 1;
            this.merge.push(0);
          } else {
            this.merge.push(1);
            this.mergeRowIndex = i;
          }
        }
      }
    },
    tableCellMerge: function tableCellMerge(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (['dailyNo'].includes(column.property)) {
        var _row = this.merge[rowIndex];

        var _col = _row > 0 ? 1 : 0;

        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    onChangeStation: function onChangeStation() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.showSelSeller = false;
                _context5.next = 3;
                return getStationOilTankInfoList({
                  stationId: _this5.searchInfo.stationId,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 3:
                res = _context5.sent;
                _this5.tankList = res.data.list;

                _this5.$forceUpdate();

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onAdd: function onAdd() {
      this.$router.push({
        name: 'BairunStationCheckAdd',
        query: {},
        params: {
          meta: {
            title: '新增油品盘点登记'
          },
          gobackParam: {
            isGoback: true
          },
          action: 'add'
        }
      });
    },
    onUpdate: function onUpdate(row) {
      this.$router.push({
        name: 'BairunStationCheckUpdate',
        query: {},
        params: {
          meta: {
            title: '变更油品盘点登记'
          },
          gobackParam: {
            isGoback: true
          },
          action: 'update',
          dailyNo: row.dailyNo
        }
      });
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteStationCheck(row).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.getTableData();
          }
        }, function (err) {});
      }).catch(function (err) {});
    }
  }
};